var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{staticStyle:{"height":"100% !important"}})
}
var staticRenderFns = []

export { render, staticRenderFns }